import React, { useState } from "react";
import { css } from "styled-components/macro";
import { NavLink } from "react-router-dom";
import { FooterContainer, FooterButtons } from "../../UI/general";
import MainRoutesConfig from "./../../../utils/mainRoutesConfig";
function Footer() {
  return (
    <FooterContainer>
      {MainRoutesConfig.map(({ button, path, exact }) => (
        <FooterButtons
          exact={exact}
          to={path}
          className={button.isMain ? "main" : "normal"}
        >
          <i className={button.icon}></i>
          {button.title}
        </FooterButtons>
      ))}
    </FooterContainer>
  );
}
export default Footer;
